// extracted by mini-css-extract-plugin
export default {"container":"article-content_container__s7F7G","content":"article-content_content__dUhKp","sidebar":"article-content_sidebar__9NQNg"};